/**
 * Created by tofael on 3/23/17.
 */

import Menu from './menu';
import React  from 'react';
import Avatar from './avatar';
import AppTitle from './app-title';
import Drawer from 'material-ui/Drawer';
import {getUser} from '../../utility/local-storage';

const LeftDrawer = (props) => {
  const { navDrawerOpen, username, menus, id } = props;
  
  const styles = {
    drawer: {
      backgroundColor: '#1C2B36',
    }
  };

  const user = getUser(id);
  
  return (
      <Drawer
          docked={true}
          containerStyle={styles.drawer}
          open={navDrawerOpen}>
        <AppTitle/>

        <Avatar username={username} photo={user.photo} id={id}/>

        <Menu menus={menus}/>
      </Drawer>
  );
};

export default LeftDrawer;



// WEBPACK FOOTER //
// ./src/screens/layout/left-drawer.js